// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-9a08a112]{display:none}.information-item[data-v-9a08a112]{align-items:center;display:flex}.information-item-icon[data-v-9a08a112]{display:flex;flex-shrink:0}.information-item-content[data-v-9a08a112]{flex:1 1 0%;margin-left:.625rem}.information-item-content-text[data-v-9a08a112]{font-size:14px;font-weight:400;line-height:20px;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
